import React from 'react'
import { MAINTENANCE_CONFIG, isFeatureAllowed } from '../config/maintenance'
import { shouldShowBookingIn, getBookingButtonText } from '../config/booking';

const DoctorSection = () => {
  const qualifications = [
    "BAMS (Bachelor of Ayurvedic Medicine and Surgery)",
    "MD in Ayurveda from prestigious institutions",
    "15+ years of clinical experience",
    "Specialized in Panchakarma therapy",
    "Certified in Pulse diagnosis (Nadi Pariksha)",
    "Member of National Ayurveda Association"
  ]

  const specializations = [
    {
      title: "Panchakarma Therapy",
      description: "Expert in all five detoxification procedures"
    },
    {
      title: "Chronic Disease Management",
      description: "Diabetes, Arthritis, Hypertension, and more"
    },
    {
      title: "Women's Health",
      description: "PCOS, Fertility, Menstrual disorders"
    },
    {
      title: "Stress & Mental Health",
      description: "Anxiety, Depression, Sleep disorders"
    }
  ]

  return (
    <section id="doctor" className="py-20 bg-gradient-to-br from-green-50 to-brown-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Meet Our <span className="text-green-600">Chief</span> <span className="text-brown-600">Physician</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience healing under the guidance of our expert Ayurvedic practitioner with years of dedicated service 
            in traditional medicine and holistic wellness.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Doctor Image and Basic Info */}
          <div className="relative">
            <div className="bg-white p-8 rounded-3xl shadow-2xl">
              <div className="relative">
                {/* <img
                  src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
                  alt="Dr. D. Sravani - Chief Ayurvedic Physician"
                  className="w-full h-96 object-cover rounded-2xl"
                /> */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
              </div>
              
              <div className="mt-6 text-center">
                <h3 className="text-3xl font-bold text-gray-900">Dr. Devarapalli Sravani</h3>
                <p className="text-xl text-green-600 font-semibold mt-2">Chief Ayurvedic Physician</p>
                <p className="text-brown-600 font-medium">BAMS, MD (Ayurveda)</p>
                
                <div className="mt-6 flex justify-center space-x-4">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-green-600">15+</div>
                    <div className="text-sm text-gray-600">Years Experience</div>
                  </div>
                  <div className="text-center border-l border-gray-300 pl-4">
                    <div className="text-2xl font-bold text-brown-600">1000+</div>
                    <div className="text-sm text-gray-600">Patients Treated</div>
                  </div>
                  <div className="text-center border-l border-gray-300 pl-4">
                    <div className="text-2xl font-bold text-green-600">50+</div>
                    <div className="text-sm text-gray-600">Treatments Mastered</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* Doctor Details */}
          <div className="space-y-8">
            {/* About */}
            <div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">About Dr. Devarapalli Sravani</h4>
              <p className="text-gray-600 leading-relaxed">
                Dr. Devarapalli Sravani is a renowned Ayurvedic physician with over 15 years of experience in traditional 
                Indian medicine. She combines ancient wisdom with modern diagnostic techniques to provide comprehensive 
                healthcare solutions. Her compassionate approach and deep understanding of Ayurvedic principles have 
                helped thousands of patients achieve optimal health and wellness.
              </p>
            </div>

            {/* Qualifications */}
            <div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Qualifications & Certifications</h4>
              <ul className="space-y-2">
                {qualifications.map((qualification, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-green-600 mr-3 mt-1">✓</span>
                    <span className="text-gray-600">{qualification}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Specializations */}
            <div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">Areas of Specialization</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {specializations.map((spec, index) => (
                  <div key={index} className="bg-white p-4 rounded-lg shadow-md">
                    <h5 className="font-semibold text-gray-900 mb-2">{spec.title}</h5>
                    <p className="text-sm text-gray-600">{spec.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact CTA */}
            {shouldShowBookingIn('DoctorSection') && (
              <div className="bg-gradient-to-r from-green-100 to-brown-100 p-6 rounded-xl">
                <h5 className="text-xl font-bold text-gray-900 mb-2">Book a Personal Consultation</h5>
                <p className="text-gray-600 mb-4">
                  Get personalized Ayurvedic treatment plan designed specifically for your health needs.
                </p>
                {isFeatureAllowed('contact') ? (
                  <a
                    href="#contact"
                    className="bg-gradient-green text-white px-6 py-3 rounded-full font-semibold hover:bg-green-700 transition-colors duration-200 inline-block"
                  >
                    {getBookingButtonText('secondary')}
                  </a>
                ) : (
                  <div className="bg-orange-100 text-orange-700 px-6 py-3 rounded-full font-semibold inline-block border border-orange-200">
                    Under Maintenance
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default DoctorSection
